import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {OrderService} from '../services/order.service';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})
export class PaymentComponent implements OnInit {
  public payment;
  public order;

  constructor(private router: Router,
              private orderService: OrderService,
              private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams
      .subscribe(paramsN => {
        this.order = paramsN;
      });
    if (localStorage.getItem('paymentMode') === 'driver'){
      this.payment = 'success';
    } else {
      this.verify();
    }
  }

  verify(): any {
    this.orderService.verify(this.order).subscribe(
      (res) => {
        if (res.data.status_code === 200){
          this.payment = 'success';
        } else {
          this.payment = 'fail';
        }
      }
    );
  }
}
